<template lang="pug">
.uc-themed-svg.inline-flex.items-center.justify-center.not-prose(
  class="uc-themed-svg"
  :data-src="src"
  ref="elRef"
  v-html="elHtml"
)
</template>

<script setup lang="ts">
import useThemedSvg from '../lib/useThemedSvg';
import { ref, computed } from 'vue';

const elRef = ref<HTMLElement>();
const props = defineProps<{ src: string }>();
const svg = useThemedSvg(props, { elRef });

// create an image using a data URL src from the SVG raw string
const elHtml = computed(() =>
  svg.value
    ? `<img src="data:image/svg+xml;utf8,${encodeURIComponent(svg.value)}" />`
    : ''
);
</script>

<style>
.uc-themed-svg svg,
.uc-themed-svg img {
  width: 100%;
  height: auto;
}
</style>
